import { AppliedVoucherTypes } from '@as-react/common-types';
import { prefixPriceWithCurrency } from '@as-react/common-utils';
import AsNumeral from '../vendors/asNumeral';
class VoucherUtil {
    static mapBasketAppliedVouchersToAppliedVouchers(vouchers, currency, t) {
        return vouchers.map((voucher) => {
            const amount = {
                amountOriginal: AsNumeral.formatAsCurrency(voucher.amountOriginal),
                amountUnused: AsNumeral.formatAsCurrency(voucher.amountUnused),
                amountUsedForThisBasket: AsNumeral.formatAsCurrency(voucher.amountUsedForThisBasket),
            };
            const formattedAmountUnused = prefixPriceWithCurrency(amount.amountUnused, currency);
            return Object.assign(Object.assign({}, voucher), { title: this.getVoucherTitle(voucher, t), info: this.getVoucherInfo(voucher, formattedAmountUnused, t), amount: amount });
        });
    }
    static getVoucherTitle(voucher, t, hideVoucherCode) {
        const displayCode = hideVoucherCode ? '' : `: ${voucher.displayCode}`;
        if (voucher.type === AppliedVoucherTypes.GIFT) {
            return `${t('checkout:checkout.basket.voucher.type.giftvoucher')}${displayCode}`;
        }
        if ((voucher.type === AppliedVoucherTypes.UNIQUE_DISCOUNT || voucher.type === AppliedVoucherTypes.PAYBACK) &&
            voucher.description) {
            return `${voucher.description}${displayCode}`;
        }
        return `${t('checkout:checkout.basket.voucher.type.voucher')}${displayCode}`;
    }
    static getVoucherInfo({ type, singleUse }, amountUnused, t) {
        if (!singleUse) {
            return `${t('checkout:checkout.basket.voucher.multiUse')} ${amountUnused}`;
        }
        if (type === AppliedVoucherTypes.PAYBACK) {
            return `${t('checkout:checkout.basket.voucher.payback')} ${amountUnused}`;
        }
        if (type === AppliedVoucherTypes.CREDIT) {
            return t('checkout:checkout.basket.voucher.restValue', { amount: amountUnused });
        }
        return `${t('checkout:checkout.basket.voucher.singleUse.attention.1')}${amountUnused}${t('checkout:checkout.basket.voucher.singleUse.attention.2')} ${t('checkout:checkout.basket.voucher.singleUse.shop.along')}`;
    }
}
export default VoucherUtil;
